import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { getLoveTemplates, generateLoveSVG } from '../utils/loveTemplates';

const LoveCardModal = ({ onSend, onClose }) => {
  const { t } = useTranslation();
  const LOVE_TEMPLATES = getLoveTemplates(t);
  const [selectedTemplate, setSelectedTemplate] = useState(LOVE_TEMPLATES[0].id);
  const [message, setMessage] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const canvasRef = useRef(null);
const [isSending, setIsSending] = useState(false);

  const currentSVG = generateLoveSVG(selectedTemplate, recipientName, message, t);

  const handleSend = async () => {
setIsSending(true);
    const svgWithSize = currentSVG.replace(
      '<svg',
      '<svg width="600" height="400" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"'
    );

    const blob = new Blob([svgWithSize], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onerror = (err) => console.error('Erreur chargement SVG:', err);

    img.onload = () => {
      const canvas = canvasRef.current;
      const scale = 4;
      canvas.width = 600 * scale;
      canvas.height = 400 * scale;

      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.scale(scale, scale);
      ctx.drawImage(img, 0, 0, 600, 400);

      URL.revokeObjectURL(url);

      canvas.toBlob((pngBlob) => {
        if (!pngBlob || pngBlob.size === 0) {
          console.error('❌ Canvas vide !');
          return;
        }
        const fileName = `love-card-${Date.now()}.png`;
        const fileObj = new Blob([pngBlob], { type: 'image/png' });
        Object.defineProperty(fileObj, 'name', { value: fileName, writable: false });
        Object.defineProperty(fileObj, 'lastModified', { value: Date.now(), writable: false });
        onSend(fileObj);
      }, 'image/png');
    };

    img.src = url;
  };

  return (
    <div className="birthday-modal-overlay" onClick={onClose}>
      <div className="birthday-modal" onClick={e => e.stopPropagation()}>
        <button className="btn-close" onClick={onClose}>✕</button>
        <h3>💝 {t('love_card.modal_title')}</h3>

        <input
          type="text"
          placeholder={t('love_card.recipient_placeholder')}
          value={recipientName}
          onChange={e => setRecipientName(e.target.value)}
          maxLength={40}
          style={{ width: '100%', marginBottom: '10px' }}
        />

        <div className="birthday-styles">
          {LOVE_TEMPLATES.map(tpl => (
            <button
              key={tpl.id}
              className={`style-btn ${selectedTemplate === tpl.id ? 'active' : ''}`}
              onClick={() => setSelectedTemplate(tpl.id)}
            >
              {tpl.label}
            </button>
          ))}
        </div>

        <textarea
          placeholder={t('love_card.message_placeholder')}
          value={message}
          onChange={e => setMessage(e.target.value)}
          maxLength={200}
          rows={2}
          className="textarea"
	style={{ width: '100%' }}

        />
        <span style={{ fontSize: '0.75rem', opacity: 0.6 }}>
          {message.length}/200
        </span>

        <div
          className="birthday-preview"
          dangerouslySetInnerHTML={{ __html: currentSVG }}
        />

 {/* Bouton envoyer */}
<div style={{ display: 'flex', gap:'20px', alignItems: 'center' }}>
<span>
        <button
          className="buttonFile1"
          onClick={handleSend}
disabled={isSending}
                  >
         {isSending ? '⏳' : '💝'} {t('love_card.send')}
        </button>
</span>

{isSending && (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
    <div className="spinner"></div>
    <span style={{ fontSize: '0.9rem', color: '#007bff' }}>
      {t('discussion.moderate') || 'Envoi en cours...'}
    </span>
  </div>
)}
</div>

        

        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </div>
    </div>
  );
};

export default LoveCardModal;